var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 316.73 316.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #942aa8;\n      }\n\n      .cls-2 {\n        fill: #8ee323;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 316.73,
    height: 316.73,
    rx: 31.67,
    ry: 31.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178,190.77l46.78,46.78h-44.79l-35.58-35.58c-6.18-6.18-6.18-16.21,0-22.39l100.39-100.39h44.79l-111.59,111.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.72,134.78l-102.77,102.77H27.15l113.97-113.97-44.4-44.4h44.8l33.2,33.2c6.18,6.18,6.18,16.21,0,22.4h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXedicon);
export default __webpack_public_path__ + "static/media/xedicon.eed22acef280984b6158f2ed656bc926.svg";
export { ForwardRef as ReactComponent };